import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventAttendingEmployersComponent } from './event-attending-employers/event-attending-employers.component';
import { EventOverviewComponent } from './event-overview/event-overview.component';
import { EventViewComponent } from './event-view/event-view.component';
import { ResolveEventView, ResolveEventOverview, ResolveEventAttendingEmployers, ResolveEventAttendingEmployerView } from './event-view/event-view.resolvers';
import { EventsComponent } from './events.component';
import { PastComponent } from './past/past.component';
import { UpcomingComponent } from './upcoming/upcoming.component';
import { CanActivateOverview } from './events.guards';
import { EventAttendingEmployerViewComponent } from './event-attending-employer-view/event-attending-employer-view.component';

export const EVENTS_ROUTES: Routes = [
    {
        path: '',
        component: EventsComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'upcoming'
            },
            {
                path: 'upcoming',
                component: UpcomingComponent
            },
            {
                path: 'past',
                component: PastComponent
            }
        ]
    },
    {
        path: ':eventId',
        component: EventViewComponent,
        resolve: {
            resolvedData: ResolveEventView
        },
        canActivate: [ CanActivateOverview ],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'overview'
            },
            {
                path: 'overview',
                component: EventOverviewComponent,
                resolve: {
                    resolvedData: ResolveEventOverview
                }
            },
            {
                path: 'employers',
                component: EventAttendingEmployersComponent,
                resolve: {
                    resolvedData: ResolveEventAttendingEmployers
                }
            },
            {
                path: 'employers/:id',
                component: EventAttendingEmployerViewComponent,
                resolve: {
                    resolvedData: ResolveEventAttendingEmployerView
                }
            },
            {
                path: '**',
                redirectTo: 'overview'
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(EVENTS_ROUTES)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        // Resolvers
        ResolveEventView,
        ResolveEventOverview,
        ResolveEventAttendingEmployers,
        ResolveEventAttendingEmployerView,
        // Guards
        CanActivateOverview
    ]
})
export class EventsRoutingModule {}
